import type { FC, ReactNode } from "react";
import { computeInterviewSectionEstimatedDuration } from "../interviewSections/definitions/helpers.js";
import type { VisibleInterviewSectionDefinition } from "../interviewSections/definitions/state.js";

interface LessonItemDurationProps {
  section: VisibleInterviewSectionDefinition | undefined;
}

/** Displays the estimated duration badge */
export const LessonItemDuration: FC<LessonItemDurationProps> = ({
  section,
}) => {
  return (
    <div className="flex items-center space-x-3">
      <span className="rounded-md bg-gray-100 px-2 py-0.5 text-xs font-semibold text-muted-foreground">
        {renderDuration(section)}
      </span>
    </div>
  );
};

function renderDuration(
  section: VisibleInterviewSectionDefinition | undefined,
): ReactNode {
  if (!section) {
    return <span>? min</span>;
  }

  const [minDuration, maxDuration] =
    computeInterviewSectionEstimatedDuration(section);

  if (minDuration === maxDuration) {
    return <span>{minDuration} min</span>;
  }

  return (
    <span>
      {minDuration}–{maxDuration} min
    </span>
  );
}
